import { IColumnRenderProps } from '../models/IColumnRenderProps'

export const ColumnRender = ({ item, column, caption }: IColumnRenderProps) => {
  if (column.field === caption) {
    return item[caption]
  }

  return null
}
